/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_my_hp_low = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.NO] = new TreeNode(null, null);

  node.branches[node.YES] =
    BattleCalc.getEquippedAbility(actor, 'shield_block') &&
    actor.equipment?.off_hand?.type === 'shield'
      ? new UseAbility({
          actor,
          abilityHandle: 'shield_block',
          staticTarget: actor,
          altNode: node.branches[node.NO],
        })
      : node.branches[node.NO];

  node.query = function () {
    if (this.yesNoEvalFunction()) {
      return this.branches[this.YES].query();
    } else {
      return this.branches[this.NO].query();
    }
  };

  node.yesNoEvalFunction = function () {
    return this.actor.hp / this.actor.max_hp < 0.6;
  };

  return node;
};
module.exports = Q_my_hp_low;
